import React from 'react';
import { UserForm } from './Form';

export default function UsersCreate(props) {
    return (
        <div className="max-w-[1200px] mx-auto px-4">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                <UserForm {...props} />
            </div>
        </div>
    );
}
